var $ = require("jquery");
var dateFormat = require('dateformat');
var Pikaday = require("pikaday");
var moment = require("moment");
var parse = require("url-parse");


var selectors = {
    datepicker: '[data-date-picker]',
    calAnchor: '[data-cal-anchor]',
};
var classes = {};
var attrs = {
    calendarDate: "data-calendar-date"
};

function padStr(str, userOptions) {
    if (!str) {
        return str;
    }

    var defaults = { dir: "left", len: 1, token: "0", };
    var options = $.extend({}, defaults, userOptions);

    if (str.length > options.len) {
        return str;
    }

    pad = options.token.repeat
        ? options.token.repeat(options.len)
        : Array(options.len + 1).join(options.token);

    if (options.dir == "left") {
        return pad + str
    }
    if (options.dir == "right") {
        return str + pad;
    }
}

function dateAsParams(date) {
    var _moment = moment(date);
    return momentAsParams(_moment);
}

function momentAsParams(moment) {
    return {
        year: moment.format("YYYY"),
        month: moment.format("M"),
        day: moment.format("DD"),
    }
}

function momentAsQueryString(moment) {
    return moment.format('[year=]YYYY[&month=]M[&day=]DD');
}

/**
 * EventCalendar Constructor
 * @param {HTMLElement} el
 * @param {any} config
 */
function EventCalendar(el, config) {
    config = config || {};
    var defaults = { renderImmediately: true, };
    var options = $.extend({}, defaults, config);
    var errors = {};

    if (!el) errors["el"] = "el is required.";

    if (!$.isEmptyObject(errors)) {
        console.warn("ConfigError(s)", errors);
        return;
    }

    this.el = el;
    this.options = options;
    this.selectors = selectors;
    this.classes = classes;
    this.attrs = attrs;
    this.init(el, options);

    if (options.renderImmediately) this.render();
}


EventCalendar.prototype = $.extend({}, EventCalendar.prototype, {
    init: function (el, options) {
        // ...
    },

    render: function () {
        var el = this.el;
        var options = this.options;
        var $el = this.render$El(el, options);
        var $ui = this.render$Ui($el, options);
        var parseQueryStr = true;
        var parsedUrl = parse(window.location, parseQueryStr);
        var calendarMoment;
        var picker;

        if (!$el.length) {

            return;
        }

        this.bindEvents($el, $ui, options);
        this.$el = $el;
        this.$ui = $ui;
        this.parsedUrl = parsedUrl;

        calendarMoment = moment(this.$el.attr(this.attrs.calendarDate));
        picker = this.renderDatePicker(this.$el, this.$ui);

        this.calendarMoment = calendarMoment;
        this.picker = picker;

        this.autoSetPickerDate();
        this.autoScroll();
    },

    render$El: function (el, options) {
        return $(el);
    },

    render$Ui: function ($el, options) {
        return {
            $datepicker: $(this.selectors.datepicker, $el),
            $calAnchor: $(this.selectors.calAnchor, $el),
        };
    },

    bindEvents: function ($el, $ui, options) {
        // ...
    },

    renderDatePicker: function ($el, $ui) {
        var $datepicker = $ui.$datepicker;
        var options = {
            field: $datepicker.get(0),
            format: "YYYY M DD",
            onSelect: this.onDatePickerSelect.bind(this),
            position: "bottom right",
        }
        return new Pikaday(options);
    },

    onDatePickerSelect: function (date) {
        var picker = this.picker;
        var cal = momentAsParams(this.calendarMoment);
        var picked = momentAsParams(picker.getMoment());
        // NOTE: Copy this object so we don't mutate internal state
        var parseQueryStr = true;
        var parsed = parse(this.parsedUrl.toString(), parseQueryStr);
        var url;

        if (cal.month == picked.month) {
            this.scrollTo(date);
        } else {
            // NOTE: Update query params with new dates,
            //       but preserve any other existing params
            parsed.query = $.extend({}, parsed.query, picked);
            url = parsed.toString();
            window.location = url;
        }
    },

    autoSetPickerDate: function () {
        var picker = this.picker;
        var silent = true;
        picker.setDate(this._getSelectedDate(), silent);
    },

    autoScroll: function () {
        this.scrollTo(this._getSelectedDate());
    },

    _getSelectedDate: function () {
        var parsed = this.parsedUrl;
        var cal = momentAsParams(this.calendarMoment);
        var now = dateAsParams(new Date());
        var year = parsed.query.year;
        var month = padStr(parsed.query.month, { dir: "left" });
        var day = padStr(parsed.query.day, { dir: "left" });

        // NOTE: Flattening logic here to simply favor query params if present
        //       and use the current datetime as defaults
        // NOTE: day has two default cases,
        //       now.day when in the current month
        //       '01' when not
        year = year || now.year;
        month = month || now.month;
        day = day || (now.month == cal.month ? now.day : "01");
        dateStr = year + "-" + month + "-" + day;

        return moment(dateStr).toDate();
    },

    scrollTo: function (date) {
        var alignTop = true;
        this._findAnchor(date).get(0).scrollIntoView(alignTop);
    },

    _findAnchor: function (date) {
        var $anchors = this.$ui.$calAnchor;
        var $anchor;

        $anchor = this._findExactAnchor(date);
        if ($anchor.length) return $anchor;

        $anchor = this._findNearestFutureAnchor(date);
        if ($anchor.length) return $anchor;

        $anchor = $anchors.last();
        return $anchor;
    },

    _findExactAnchor: function (date) {
        return $("#" + dateFormat(date, "mm-dd"));
    },

    _findNearestFutureAnchor: function (date) {
        var tri = 0;
        var day = date.getDate()
        // +1 months are zero based :^(
        var totalDays = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
        var tries = totalDays - day;
        var anchorId;
        var $anchor;
        var dateStr;
        var nextDay = new Date(date.getTime())

        while (tri < tries) {
            nextDay.setDate(nextDay.getDate() + 1);
            dateStr = dateFormat(nextDay, "mm-dd");
            anchorId = "#" + dateStr;
            $anchor = $(anchorId);
            tri++;

            if ($anchor.length) break;
        }

        return $anchor || [];
    },
});

module.exports = EventCalendar;



//////////////////
// WEBPACK FOOTER
// ./events/js/eventCalendar.js
// module id = 148
// module chunks = 3